import { render, staticRenderFns } from "./BusquedaRut.vue?vue&type=template&id=4cd65946&"
import script from "./BusquedaRut.vue?vue&type=script&lang=js&"
export * from "./BusquedaRut.vue?vue&type=script&lang=js&"
import style0 from "./BusquedaRut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports